import type { FaireProductEntity } from "../../entity_types/product";

export const ramen_4: FaireProductEntity = {
  token: "ramen-4",
  type: "product",
  name: "Japan: theCookbook",
  brandName: "Phaidon",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/6f1e8487f553374ecb578acd93b1a5012cc7429512516eda00d656f0cdeeb503.png",
  priceDollars: 28.57,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/6f1e8487f553374ecb578acd93b1a5012cc7429512516eda00d656f0cdeeb503.png",
  weight: 2,
  dimensions: {
    width: 8,
    height: 11,
    depth: 1,
  },
  description: "Comprehensive Japanese cookbook featuring ramen recipes",
  categoryTokens: ["cat_accessories"],
  tags: ["ramen", "japanese-ramen", "cookbook", "japanese-cuisine", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
